import FileUploadComponents from '../../components/FileUploadComponents';

const FileUpload = () => {
	return <FileUploadComponents />;
};

export default FileUpload;
